<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      d="M12 6.242a1 1 0 0 1 1 1v5.517a1 1 0 1 1-2 0V7.242a1 1 0 0 1 1-1ZM10.666 16.56a1.335 1.335 0 0 0 2.667 0 1.335 1.335 0 0 0-2.667 0Z"
      fill="currentColor" /><path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.333 12.003C1.333 6.112 6.109 1.336 12 1.336c5.89 0 10.666 4.776 10.666 10.667 0 5.89-4.775 10.666-10.666 10.666S1.333 17.894 1.333 12.003ZM12 3.336a8.667 8.667 0 1 0 0 17.333 8.667 8.667 0 0 0 0-17.333Z"
      fill="currentColor" />
  </g>
</svg>
